import { render, staticRenderFns } from "./CustomNumberInput.vue?vue&type=template&id=4a0663f6&scoped=true"
import script from "./CustomNumberInput.vue?vue&type=script&lang=js"
export * from "./CustomNumberInput.vue?vue&type=script&lang=js"
import style0 from "./CustomNumberInput.vue?vue&type=style&index=0&id=4a0663f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0663f6",
  null
  
)

export default component.exports